import { Label, Touchable, useWindowSize } from '@grassrootly/rn-core';

type PlayerTabProps = {
  title: string;
  alias: string;
  isActive: boolean;
  onPress: (key: string) => void;
};

export default function PlayerTab({ title, alias, isActive, onPress }: PlayerTabProps) {
  const { isTablet } = useWindowSize();

  return <Touchable
    classNames={[
      "flex1",
      "alignItemsCenter",
      "justifyContentCenter",
      "pv8",
      "bwBottom-{1}",
      isActive ? "borderPrimary" : "borderSecondary",
    ]}
    key={alias}
    onPress={() => onPress(alias)}
  >
    <Label classNames={["textCenter"]} type={isTablet ? "l2Regular" : "l3Regular"}>{title}</Label>
  </Touchable>
};
